import React from "react";
import CustomContainer from "../../../../components/container/CustomContainer";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TableData from "../../../../json/AdmissionFee.json";
import DynamicTable from "../../../../components/table";

const tableHeader = [
  "Payment Date",
  "Fees Type",
  "Total Fee",
  "Installment",
  "Status",
];

const tableRows = ["date_time", "type", "fees", "installment", "status"];

const TuitonFee = () => {
  return (
    <CustomContainer
      primaryHeading={"Tuition Fee"}
      secondaryHeading={"View all your tuition fee history"}
      customIcom={<ReceiptIcon sx={{ fontSize: "30px" }} />}
    >
      <DynamicTable
        tableData={TableData}
        displayRows={tableRows}
        tableHeader={tableHeader}
      />
    </CustomContainer>
  );
};

export default TuitonFee;
